






import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class ListLayout extends Vue {
    // this component is needed only for styles loading
}
